import { NewsStatus, ToolbarOption } from '@common/clients/api';
import { type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';

export interface ArtikelThemeConfig {
    acceptedArticleBlocks: ToolbarOption[];
    defaultStatus: NewsStatus;
    prefillInitialAuthor: boolean;
    richNextEditorSupport: RichNextEditorSupport;
}

export const footballRelatedArticleBlocks = [
    ToolbarOption.INSERT_MATCH_BLOCK,
    ToolbarOption.INSERT_MATCH_DETAIL_SECTION,
    ToolbarOption.INSERT_PLAYER,
    ToolbarOption.INSERT_PLAYER_GRADE,
    ToolbarOption.INSERT_STANDING_BLOCK,
];

export const defaultArticleBlocks = [
    ToolbarOption.INSERT_GALLERY,
    ToolbarOption.INSERT_IFRAME,
    ToolbarOption.INSERT_IMAGES,
    ToolbarOption.INSERT_INSTAGRAM_POST,
    ToolbarOption.INSERT_LISTICLE_BLOCK,
    ToolbarOption.INSERT_JOBS_OVERVIEW,
    ToolbarOption.INSERT_MEDIA_BLOCK,
    ToolbarOption.INSERT_PAYWALL,
    ToolbarOption.INSERT_POLL,
    ToolbarOption.INSERT_POST,
    ToolbarOption.INSERT_QUOTE,
    ToolbarOption.INSERT_RELATED_BLOCK,
    ToolbarOption.INSERT_TIK_TOK_BLOCK,
    ToolbarOption.INSERT_YOUTUBE_VIDEO,
];

export enum RichNextEditorSupport {
    FULL,
    PARTIAL_HIDE_DEPRECATED_FIELDS,
    PARTIAL_SHOW_DEPRECATED_FIELDS,
}

const THEME_CONFIG: ThemeConfig<ArtikelThemeConfig> = {
    defaults: {
        acceptedArticleBlocks: defaultArticleBlocks,
        defaultStatus: NewsStatus.DRAFT,
        prefillInitialAuthor: true,
        richNextEditorSupport: RichNextEditorSupport.PARTIAL_HIDE_DEPRECATED_FIELDS,
    },
    byPlatform: {
        vi: {
            acceptedArticleBlocks: [...defaultArticleBlocks, ...footballRelatedArticleBlocks],
            richNextEditorSupport: RichNextEditorSupport.FULL,
            prefillInitialAuthor: false,
        },
        vp: {
            acceptedArticleBlocks: [...defaultArticleBlocks, ...footballRelatedArticleBlocks],
            defaultStatus: NewsStatus.PUBLISHED,
            prefillInitialAuthor: false,
            richNextEditorSupport: RichNextEditorSupport.PARTIAL_SHOW_DEPRECATED_FIELDS,
        },
        vn: {
            acceptedArticleBlocks: [...defaultArticleBlocks, ...footballRelatedArticleBlocks],
            defaultStatus: NewsStatus.PUBLISHED,
            prefillInitialAuthor: false,
            richNextEditorSupport: RichNextEditorSupport.PARTIAL_SHOW_DEPRECATED_FIELDS,
        },
    },
};

export const useArtikelThemeConfig = () => useThemeConfig(THEME_CONFIG);
